import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {NavComponent} from "./layout/nav/nav.component";
import {SidenavComponent} from "./layout/sidenav/sidenav.component";
import {LocaleService} from "./core/i18n/locale.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, NavComponent, SidenavComponent
/*
  ,NoopAnimationsModule , BrowserAnimationsModule
*/
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit{

  constructor(private localeService: LocaleService) {

  }

  title = 'admin-panel';


  ngOnInit(): void {


  }


}
